<template>
  <div id="app">
    <Navigation/>
    <router-view/>
    <Footer />
  </div>
</template>

<script>
import Navigation from '@/components/Navigation.vue';
import Footer from '@/components/Footer.vue';

export default {
  components: { Footer, Navigation },
};
</script>

<style lang="scss">
  h1{
    font-size: 2em;
    margin: 30px 0;
    width: 100%;
  }
  h2{
    font-size: 1.6em;
    width: 100%;
  }
  .main-content{
    margin-top: 19px;
    margin-bottom: 50px;
    min-height: calc(100vh - 206px);
  }
  @media screen and (min-width: 992px) {
    .main-content{
      margin-top: 50px;
      margin-bottom: 50px;
      min-height: calc(100vh - 226px);
    }
  }
  .btn-secondary, .btn-secondary:disabled{
    background: white;
    border-width: 2pt;
    color: black
  }

  .main-navigation {
    background-color:rgb(228, 23, 23);
  }

  .main-navigation .nav-link{
    color: #FFFFFF !important;
  }

  .nav-link:hover, .nav-link:active{
    text-decoration: underline;
  }
  .main-navigation .navbar-brand{
    font-weight: bold;
  }


  footer .btn-help{
    position: fixed;
    bottom: 40px;
    right: 40px;
    border-radius: 100px;
    width: 60px;
    height: 60px;
    line-height: 40px;
    font-size: 30px;
    z-index: 1001;
    font-weight: bold;
    box-shadow: 0 3px 5px -1px rgba(0,0,0,.2), 0 6px 10px 0 rgba(0,0,0,.14), 0 1px 18px 0 rgba(0,0,0,.12);
  }

  footer.footer {
    background-color: #f5f5f5;
    height: 70px;
  }
</style>
